import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function locationValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const arr = control.value.split(',');
    // control value must be the following format city, province/state, country
    // ex Brooks, AB, Canada
    if (control.value.length && control.value !== '') {
      if (arr.length < 3) {
        return { invalidDestination: true };
      }
      // Validate that none of the parts are empty
      const hasEmptyPart = arr.some((e) => e.trim() === '');
      if (hasEmptyPart) {
        return { invalidDestination: true };
      }
    }
    return null;
  };
}
